import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select'
import axiosJWT from '../../JwtToken'

export const Add = ({ getData, closeAdd, getPesan, setMsg }) => {
    const [tgl_pengajuan, setTglPengajuan] = useState(new Date().toISOString().split('T')[0])
    const [klaster, setKlaster] = useState("")
    const [nama_program, setNamaProgram] = useState("")
    const [deskripsi, setDeskripsi] = useState("")
    const [lokasi_csr, setLokasi] = useState("")
    const [kecamatan_csr, setKecamatanCsr] = useState("")
    const [kelurahan_csr, setKelurahanCsr] = useState("")
    const [latitude_csr, setLatitude] = useState("")
    const [longitude_csr, setLongitude] = useState("")
    const [nilai_csr, setNilaiCsr] = useState(0)
    const [optKecamatan, setOptKecamatan] = useState([])
    const [optKelurahan, setOptKelurahan] = useState([])

    // State Informasi Penerima Manfaat
    const [nama_penerima, setNamaPenerima] = useState("")
    const [manfaat_csr, setManfaatCsr] = useState("")

    // FORM 1: Update Progress (History Based)
    const [inputFileBukti, setInputFileBukti] = useState(null)
    const [preview, setPreview] = useState("")

    useEffect(() => {
        getKecamatan()
    }, [])

    // Integrasi Data Wilayah (Kecamatan & Kelurahan)
    const getKecamatan = async () => {
        try {
            const response = await axiosJWT.post(`/api/wilayah/kecamatan`, {
                no_prop: '32',
                no_kab: '75'
            })
            const result = response.data.map(item => ({
                value: item.nama_kec,
                label: item.nama_kec
            }))
            setOptKecamatan(result)
        } catch (err) {
            setOptKecamatan([])
        }
    }

    const noKecamatan = async (key) => {
        if (!key) {
            setKecamatanCsr("")
            setKelurahanCsr("")
            setOptKelurahan([])
            return
        }

        try {
            const response = await axiosJWT.post(`/api/wilayah/kecamatan`, {
                no_prop: '32',
                no_kab: '75',
                nama_kec: key.value
            })

            setKecamatanCsr(key.value)
            setKelurahanCsr("")

            if (response.data.length > 0) {
                getKelurahan(response.data[0].no_kec)
            }
        } catch {
            setKecamatanCsr(key.value)
            setOptKelurahan([])
        }
    }

    const getKelurahan = async (key) => {
        try {
            const response = await axiosJWT.post(`/api/wilayah/kelurahan`, {
                no_prop: '32',
                no_kab: '75',
                no_kec: key
            })
            const result = response.data.map(item => ({
                value: item.nama_kel,
                label: item.nama_kel
            }))
            setOptKelurahan(result)
        } catch {
            setOptKelurahan([])
        }
    }

    const updateKelurahan = (key) => {
        if (!key) {
            setKelurahanCsr("")
            return
        }
        setKelurahanCsr(key.value)
    }

    // LOGIC TOMBOL 1: SIMPAN PROGRESS (INSERT HISTORY & AUTO UPDATE MASTER)
    const handleSimpanProgress = async (e) => {
        e.preventDefault()
        const validationRules = [
            { condition: !tgl_pengajuan, msg: "Tanggal serah terima tidak boleh kosong!" },
            { condition: !klaster, msg: "Klaster tidak boleh kosong!" },
            { condition: !nama_program, msg: "Nama program tidak boleh kosong!" },
            { condition: !nilai_csr, msg: "Nilai tjls/csr tidak boleh kosong!" },
            { condition: !kecamatan_csr, msg: "Kecamatan tidak boleh kosong!" },
            { condition: !kelurahan_csr, msg: "Kelurahan tidak boleh kosong!" },
            { condition: !lokasi_csr, msg: "Lokasi/alamat tidak boleh kosong!" }
        ]

        // 2. CEK SATU-SATU (Short-circuit)
        const error = validationRules.find(rule => rule.condition)
        if (error) {
            setMsg(error.msg)
            getPesan()
            setTimeout(() => {
                getPesan()
            }, 2000)
            return
        }

        const formData = new FormData()
        formData.append("tgl_pengajuan", tgl_pengajuan)
        formData.append("klaster", klaster)
        formData.append("nama_program", nama_program)
        formData.append("nilai_csr", Number(nilai_csr))
        formData.append("deskripsi", deskripsi)
        formData.append("kecamatan_csr", kecamatan_csr)
        formData.append("kelurahan_csr", kelurahan_csr)
        formData.append("lokasi_csr", lokasi_csr)
        formData.append("latitude_csr", latitude_csr)
        formData.append("longitude_csr", longitude_csr)
        formData.append("nama_penerima", nama_penerima)
        formData.append("manfaat_csr", manfaat_csr)

        formData.append("file_bukti", inputFileBukti)

        try {
            await axiosJWT.post(`/api/csr/portal/create`, formData)
            setMsg("Laporan TJLS/CSR Mandiri Berhasil Disimpan!")
            getPesan()

            // Reset field input
            setInputFileBukti(null)
            setPreview("")

            getData("")

            setTimeout(() => {
                getPesan()
                closeAdd()
            }, 2000)
        } catch (err) {
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                ? err.response.data.msg
                : "Gagal update progress"

            setMsg(errorMsg)
            getPesan()

            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const loadFile = (e) => {
        const file = e.target.files[0]
        setInputFileBukti(file)
        setPreview(URL.createObjectURL(file))
    }

    return (<>
        <form onSubmit={handleSimpanProgress} className="form-horizontal">
            <h5 className="right-line color-success">Informasi TJSL/CSR</h5>
            <div className="row">
                <div className="form-group col-md-6">
                    <label className="control-label">Tanggal Serah Terima *</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-calendar"></i></span>
                        <input type="date" className="form-control" value={tgl_pengajuan} onChange={(e) => setTglPengajuan(e.target.value)} required />
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Klaster *</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-cubes"></i></span>
                        <select className="form-control" value={klaster} onChange={(e) => setKlaster(e.target.value)} required>
                            <option value="">==</option>
                            <option value="Lingkungan">Lingkungan</option>
                            <option value="Kesehatan">Kesehatan</option>
                            <option value="Pendidikan">Pendidikan</option>
                            <option value="Ekonomi">Ekonomi</option>
                            <option value="Infrastruktur">Infrastruktur</option>
                            <option value="Barang">Barang</option>
                            <option value="Jasa">Jasa</option>
                        </select>
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Nama TJSL/CSR *</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-briefcase"></i></span>
                        <input type="text" className="form-control" value={nama_program} onChange={(e) => setNamaProgram(e.target.value)} placeholder="Nama CSR" required />
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Nilai (Rp) TJSL/CSR *</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-money"></i></span>
                        <input type="number" className="form-control" value={nilai_csr} onChange={(e) => setNilaiCsr(e.target.value)} placeholder="0" required />
                    </div>
                </div>

                <div className="form-group col-md-12">
                    <label className="control-label">Deskripsi/Catatan TJSL/CSR *</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-comments-o"></i></span>
                        <textarea className="form-control" rows="3" value={deskripsi} onChange={(e) => setDeskripsi(e.target.value)} placeholder="Jelaskan singkat tentang CSR ini..." required></textarea>
                    </div>
                </div>
            </div>

            <h5 className="right-line color-success">Lokasi TJSL/CSR</h5>
            <div className="row">
                <div className="form-group col-md-6">
                    <label className="control-label">Kecamatan *</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-map"></i></span>
                        <Select className="react-select" value={optKecamatan.find(obj => obj.value === kecamatan_csr) || null} onChange={noKecamatan} options={optKecamatan} isClearable required placeholder="-- Pilih Kecamatan --" />
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Kelurahan *</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-map"></i></span>
                        <Select className="react-select" value={optKelurahan.find(obj => obj.value === kelurahan_csr) || null} onChange={updateKelurahan} options={optKelurahan} isClearable required placeholder="-- Pilih Kelurahan --" />
                    </div>
                </div>

                <div className="form-group col-md-12">
                    <label className="control-label">Lokasi *</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-location-check"></i></span>
                        <textarea className="form-control" rows="2" value={lokasi_csr} onChange={(e) => setLokasi(e.target.value)} placeholder="Alamat Lokasi..." required></textarea>
                    </div>
                    <span className="badge badge-danger">Masukan hanya alamat tanpa Kecamatan dan Kelurahan</span>
                </div>

                <div className="form-group col-md-6">
                    <label className="control-label">Latitude</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-map-pin"></i></span>
                        <input className="form-control" value={latitude_csr} onChange={(e) => setLatitude(e.target.value)} placeholder="Latitude" />
                    </div>
                    <span className="badge badge-danger">Contoh: -6.0318410</span>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Longitude</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-map-pin"></i></span>
                        <input className="form-control" value={longitude_csr} onChange={(e) => setLongitude(e.target.value)} placeholder="Longitude" />
                    </div>
                    <span className="badge badge-danger">Contoh: 108.0318410</span>
                </div>
            </div>

            <h5 className="right-line color-success">Penerima Manfaat TJSL/CSR</h5>
            <div className="row">
                <div className="form-group col-md-6">
                    <label className="control-label">Penerima</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-users"></i></span>
                        <input type="text" className="form-control" value={nama_penerima} onChange={(e) => setNamaPenerima(e.target.value)} placeholder="Nama Penerima Manfaat" />
                    </div>
                </div>

                <div className="form-group col-md-6">
                    <label className="control-label">Manfaat</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-handshake"></i></span>
                        <input type="text" className="form-control" value={manfaat_csr} onChange={(e) => setManfaatCsr(e.target.value)} placeholder="Manfaat CSR..."></input>
                    </div>
                </div>
            </div>

            <h5 className="right-line color-success">Dokumen Pendukung Kegiatan</h5>
            <div className="row">
                <div className="form-group col-md-6">
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label className="control-label">Foto Bukti Lapangan</label>
                            <div className="input-group">
                                <span className="input-group-addon"><i className="fa fa-camera"></i></span>
                                <input className="form-control" type="file" onChange={loadFile} accept="image/*" />
                            </div>
                            <span className="badge d-inline-block text-wrap badge-danger">Format: .JPG / .PNG (Maks 2MB)</span>
                        </div>

                    </div>
                </div>
                <div className="form-group col-md-6 text-center">
                    <label className="control-label">Preview Foto</label>
                    <div style={{ border: '1px solid #ddd', padding: '5px', borderRadius: '4px' }}>
                        {preview ? (
                            <img width="100%" height="200" src={preview} style={{ objectFit: 'cover' }} alt="Preview" />
                        ) : (
                            <img width="100%" height="200" src="/assets/img/no-image.png" alt="No Preview" />
                        )}
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-raised btn-success br-2 no-m" type="submit">
                    <i className="fa fa-send"></i> Kirim Laporan
                </button>
                <button type="button" onClick={closeAdd} className="btn btn-raised btn-danger br-2 no-m">
                    <i className="fa fa-sign-out"></i> Batal
                </button>
            </div>
        </form>
    </>)
}